import { memo, type MouseEvent } from 'react'
import { Button } from '@highlight/ui'
import { useAudioElapsedTime } from '@renderer/hooks/audio/useAudioElapsedTime'
import { LiveTranscriptSnippet } from '@renderer/overlay/Sidepanel/components/meeting/live-transcript-snippet'
import { AudioWaveform } from '@renderer/overlay/components/audio-waveform'

interface LiveRecordingPreviewProps {
  onView: (e: MouseEvent) => void
  viewHotkey?: string
}

/**
 * Elapsed timer + latest transcript line for the meeting card currently being
 * transcribed: the in-flight partial while someone's talking, else the last
 * finalized turn. Only mounted for that one card, so its transcript and
 * partial subscriptions don't fire for every other (idle) meeting cell.
 */
export const LiveRecordingPreview = memo(function LiveRecordingPreview({
  onView,
  viewHotkey,
}: LiveRecordingPreviewProps) {
  const elapsedTime = useAudioElapsedTime()

  return (
    <div className="flex w-full items-center justify-end gap-4">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <AudioWaveform className="shrink-0" />
        <div className="type-ui-xs flex min-w-0 flex-1 items-center gap-3 font-normal">
          <span className="text-foreground-secondary shrink-0 tabular-nums">{elapsedTime}</span>
          <LiveTranscriptSnippet />
        </div>
      </div>
      <Button onClick={onView} variant="primary" tone="inverse" hotkey={viewHotkey}>
        View
      </Button>
    </div>
  )
})
